import { B, fonts, Btn, Spinner } from "../../../components/UI";

// Designs tab keeps design discovery, filters, and stock-management actions in one place.
export default function DesignsTab({
  designs,
  activeDesigns,
  categories,
  permissions,
  showDesFm,
  editDes,
  loading,
  filteredDesigns,
  paginatedDesigns,
  desSearch,
  desCategory,
  setDesSearch,
  setDesCategory,
  setShowDesFm,
  setEditDes,
  setCrudBusy,
  handleToggleDesign,
  handleDeleteDesign,
  pageSize,
  designPage,
  totalPages,
  setDesignPage,
  DesignForm,
  DesignRow,
  showToast,
}) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, flexWrap: "wrap", gap: 10 }}>
        <p style={{ margin: 0, fontSize: 12, color: B.textLight, fontFamily: fonts.body }}>{designs.length} total · {activeDesigns.length} active</p>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <input value={desSearch} onChange={e => setDesSearch(e.target.value)} placeholder="Search design no, color, fabric..."
            style={{ background: B.white, border: `1.5px solid ${B.border}`, borderRadius: 8, padding: "8px 13px", fontSize: 12, color: B.text, fontFamily: fonts.body, outline: "none", width: 180 }} />
          <select value={desCategory} onChange={e => setDesCategory(e.target.value)}
            style={{ background: B.white, border: `1.5px solid ${B.border}`, borderRadius: 8, padding: "8px 10px", fontSize: 12, color: B.text, fontFamily: fonts.body, outline: "none", minWidth: 160 }}>
            <option value="all">All categories</option>
            {categories.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
          {permissions?.canManageDesigns && !showDesFm && !editDes && (
            <Btn onClick={() => setShowDesFm(true)} variant="primary">+ Add Design</Btn>
          )}
        </div>
      </div>
      {permissions?.canManageDesigns && (showDesFm || editDes) && (
        <DesignForm initial={editDes} categories={categories}
          onDone={() => { setShowDesFm(false); setEditDes(null); }}
          showToast={showToast}
          onSavingChange={setCrudBusy} />
      )}
      {loading ? <Spinner /> : filteredDesigns.length === 0
        ? <div style={{ textAlign: "center", padding: 48, color: B.textLight, background: B.white, borderRadius: 12, border: `1px dashed ${B.border}`, fontFamily: fonts.body }}>No designs yet.</div>
        : paginatedDesigns.map(d => (
          <DesignRow key={d.id} design={d}
            canDelete={permissions?.canDeleteDesigns}
            onEdit={d => { if (!permissions?.canManageDesigns) return; setEditDes(d); setShowDesFm(false); window.scrollTo(0, 0); }}
            onToggle={handleToggleDesign}
            onDelete={handleDeleteDesign} />
        ))
      }
      {!loading && filteredDesigns.length > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 14, gap: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 12, color: B.textLight, fontFamily: fonts.body }}>
            Showing {(designPage - 1) * pageSize + 1}-{Math.min(designPage * pageSize, filteredDesigns.length)} of {filteredDesigns.length}
          </span>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn onClick={() => setDesignPage(p => Math.max(1, p - 1))} variant="ghost" small disabled={designPage === 1}>Previous</Btn>
            <span style={{ fontSize: 12, color: B.textMid, alignSelf: "center", fontFamily: fonts.body }}>Page {designPage} / {totalPages}</span>
            <Btn onClick={() => setDesignPage(p => Math.min(totalPages, p + 1))} variant="ghost" small disabled={designPage === totalPages}>Next</Btn>
          </div>
        </div>
      )}
    </div>
  );
}
